export const APPLE_PAY_STORE_NAME = 'McGraw Hill';

/**
 * Checks if the device supports Apple Pay.
 */
export function isApplePaySupported(): boolean {
  try {
    if (!(window as any).ApplePaySession || !(window as any).ApplePaySession.supportsVersion(3)) {
      console.error('This device does not support Apple Pay');
      return false;
    }

    if (!(window as any).ApplePaySession.canMakePayments()) {
      console.error('This device is not capable of making Apple Pay payments');
      return false;
    }
  } catch (error) {
    console.error(error);
    return false;
  }

  return true;
}

/**
 * Returns the last digits of the credit card number.
 *
 * For example "Visa 1234" will return "1234".
 *
 * @param cardNumber
 */
export function getLastCardDigits(cardNumber: string): string {
  const match = cardNumber.match(/\d+$/);
  if (!match) {
    return '';
  }

  return match[0];
}
